import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/system';
import EditIcon from '@mui/icons-material/Edit';
import FileCopyRoundedIcon from '@mui/icons-material/FileCopyRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { getContrastColor } from '#component/theme';
import { getAddressString } from '#component/addressbook/helper';
import { SUCCESS } from '#action/types';
import { deleteAddressbookContact } from '#action/addressbook/addressbook-contact';
import { fetchContacts } from '#action/addressbook/addressbook-contacts-paginated';
import DeleteContactDialog from '#component/addressbook/dashboard/delete-contact-dialog';
import { writeToClipboard } from '#helper';

const StyledEditIcon = styled(EditIcon)(() => ({
  color: getContrastColor(),
  marginRight: 5
}));

const StyledFileCopyIcon = styled(FileCopyRoundedIcon)(() => ({
  color: getContrastColor(),
  marginRight: 5
}));

const StyledDeleteIcon = styled(DeleteRoundedIcon)(({ theme }) => ({
  color: 'rgba(0, 0, 0, 0.54)',
  marginRight: theme.spacing()
}));

const getDialogContentText = contact => {
  let text = 'Do you want to delete the "';

  if (contact.firstName || contact.lastName) {
    text += `${contact?.firstName ?? ''} ${contact?.lastName ?? ''}`;
  } else if (contact.companyName) {
    text += contact.companyName;
  }
  text += '"?';
  return text;
};

const ContactActions = props => {
  const { anchorEl, setAnchorEl = () => null, contact } = props;
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopyAddressClick = () => {
    const addressString = getAddressString(contact);
    writeToClipboard(addressString);
    dispatch({
      type: SUCCESS,
      payload: {
        message: 'Address copied to clipboard'
      }
    });
    handleClose();
  };

  const handleDeleteClick = () => {
    setOpen(true);
  };

  const handleDeleteClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    const result = await dispatch(deleteAddressbookContact(contact?.id));
    if (result?.success) {
      handleDeleteClose();
      dispatch(fetchContacts({ refetchAddressbooks: true }));
    }
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          component={Link}
          to={`/addressbook/contact/edit/${contact.id}`}
        >
          <StyledEditIcon />
          Edit contact
        </MenuItem>
        <MenuItem onClick={handleCopyAddressClick}>
          <StyledFileCopyIcon />
          Copy address
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>
          <StyledDeleteIcon />
          Delete
        </MenuItem>
      </Menu>
      <DeleteContactDialog
        open={open}
        dialogContentText={getDialogContentText(contact)}
        onClose={handleDeleteClose}
        onDelete={handleDelete}
      />
    </>
  );
};

export default ContactActions;
